<template>
  <router-link
    v-for="supplier in suppliers"
    :key="supplier.id"
    :to="{ name: 'SupplierPage', params: { id: supplier.id } }"
    class="flex items-center gap-2 p-2 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-sm"
  >
    <Image :src="getFlagUrl(supplier.country)" :alt="supplier.country" class="w-5 h-4" image-class="rounded-sm" />
    <span class="text-sm">{{ supplier.companyName }}</span>
  </router-link>
</template>

<script setup>
import { getFlagUrl } from '@/utils/helpers'
import { Image } from 'primevue'

defineProps({
  suppliers: { type: Array, default: () => [] },
})
</script>
